'use strict';

(function (Accordion, $, undefined) {

  var bindUIActions = function bindUIActions() {
    $('[data-toggle-accordion]').on('click', function () {
      var $accordion = $(this).closest('.accordion-new');
      var $content = $(this).next();

      $('.accordion-new__content').slideUp(300);
      $('.accordion-new').removeClass('accordion-new--open');

      if ($content.is(':visible')) {
        $accordion.removeClass('accordion-new--open');
        $content.slideUp(300).promise().done(function () {
          Waypoint.refreshAll();
        });
      } else {
        $accordion.addClass('accordion-new--open');
        $(this).next().slideDown(300).promise().done(function () {
          Waypoint.refreshAll();
        });;
      }
    });
  };

  Accordion.init = function () {
    bindUIActions();
  };
})(window.Accordion = window.Accordion || {}, jQuery);
(function (AddToCart, $, undefined) {

  var bindUIActions = function bindUIActions() {
    $('[data-disabled]').on('click', function () {
      if ($(this).is('[data-disabled]')) {
        $('[data-select-cta]').addClass('select-cta--open select-cta__side--warn');
      }
    });

    $('[data-variant-select-item]').on('click', function (e) {
      var variantQty = $(this).attr('data-variant-quantity');
      var variantId = $(this).attr('data-variant-id');
      var variantPrice = $(this).attr('data-variant-price');
      var variantTitle = $(this).attr('data-variant-title');
      var productId = $(this).attr('data-product-id');
      var productTitle = $(this).attr('data-product-title');
      var isToggle = $(this).attr('data-is-toggle');
      var isOpen = $(this).closest('[data-select-cta]').hasClass('select-cta--open');
      var isShop = $(this).attr('data-is-shop');
      var productType = $(this).attr('data-product-type');
      var productHandle = $(this).attr('data-variant-select-item');
      var outOfStock = $(this).attr('data-variant-out-of-stock');

      if (isOpen) {
        $('.select-cta__btn').removeClass('select-cta__btn--selected');
        $(this).addClass('select-cta__btn--selected');
      }
      $(this).closest('[data-select-cta]').toggleClass('select-cta--open');

      if (isShop) {
        $(this).closest('[data-product-tile]').find('[data-product-type]').hide();
        $(this).closest('[data-product-tile]').find('[data-product-type=' + productType + ']').show();
      } else {
        if (isToggle) {
          $('[data-variant-add-to-cart]').attr('data-disabled', true);
        } else {
          $('[data-variant-add-to-cart]').removeAttr('data-disabled');
          $('[data-select-cta]').removeClass('select-cta__side--warn');
          if (outOfStock === 'true') {
            $('[data-variant-add-to-cart]').hide();
            $('[data-backordered]').attr('data-remodal-target', productHandle).show();
          } else {
            $('[data-backordered]').hide();
            $('[data-variant-add-to-cart]').show().attr({
              'disabled': false,
              'data-variant-quantity': variantQty,
              'data-variant-id': variantId,
              'data-variant-price': variantPrice,
              'data-variant-title': variantTitle,
              'data-product-id': productId,
              'data-product-title': productTitle
            });
          }
        }
      }
    });
  };

  AddToCart.init = function () {
    bindUIActions();
  };
})(window.AddToCart = window.AddToCart || {}, jQuery);
(function (Affirm, $, undefined) {

  var bindUIActions = function bindUIActions() {

    $('[data-affirm-modal-trigger]').on('click', function (e) {
      e.preventDefault();
      affirm.ui.openModal();
    });

    if (queryParams.affirmModal === "true") {
      affirm.ui.openModal();
    }

    if (queryParams.affirmFeature === "true") {
      Scroll.smoothScroll($('#affirm'), $('.site-header').outerHeight(), 0);
      affirm.ui.openModal();
    }
  };

  Affirm.init = function () {
    affirm.ui.ready(function () {
      bindUIActions();
    });
  };
})(window.Affirm = window.Affirm || {}, jQuery);
(function (Download, $, undefined) {
  var bindUIActions = function bindUIActions() {
    $(document).on('click', '[data-download]', function (e) {
      e.preventDefault();
      var downloadUrl = $(this).attr('data-download');
      console.log(downloadUrl);

      if (downloadUrl.indexOf(',') > -1) {
        var downloads = downloadUrl.slice(0, -1).split(',');

        for (var i = 0; i < downloads.length; i++) {
          download(downloads[i]);
        }
      } else {
        download(downloadUrl);
      }
    });
  };

  Download.init = function () {
    bindUIActions();
  };
})(window.Download = window.Download || {}, jQuery);
(function (Forms, $, undefined) {
  var bindUIActions = function bindUIActions() {
    $('[data-mailchimp-form]').on('submit', function (e) {
      e.preventDefault();

      var $form = $(this);

      var newsletterSource = $form.attr('data-newsletter-source');

      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: function error(err) {
          alert("Could not connect to the registration server. Please try again later.");
        },
        success: function success(data) {
          var message = '<p>' + data.msg + '</p>';

          if ($(message).find('a').length) {
            message = $(message).find('a').addClass('text-link text-link--same').parent();
          }

          $form.find('[data-form-message]').html(message).slideDown();

          if (newsletterSource) {
            ga('send', {
              hitType: 'event',
              eventCategory: 'Newsletter',
              eventAction: 'Signup',
              eventLabel: newsletterSource
            });

            // TRACK SEGMENT EVENT
            analytics.track('User Subscribed to Newsletter', {
              newsletterSource: newsletterSource
            });
          }
        }
      });
    });
  };

  Forms.init = function () {
    bindUIActions();
  };
})(window.Forms = window.Forms || {}, jQuery);
(function (GaTest, $, undefined) {

  var checkLegacyVariation = function checkLegacyVariation() {
    var isLegacyVariation = getCookie('ss.legacyVariation');
    console.log(isLegacyVariation);

    if (isLegacyVariation) {
      var $newIndexLinks = $('a[href="/"]');
      var $newShopLinks = $('a[href="/collections/soloshot3"]');
      $('[data-hide-test]').hide();
      $($newIndexLinks).each(function () {
        $(this).attr('href', '/pages/soloshot-home');
      });
      $($newShopLinks).each(function () {
        $(this).attr('href', '/collections/all');
      });
    }
  };

  GaTest.init = function () {
    $(document).on('ready', function () {
      if (window.location.href.indexOf('soloshot-home') > -1) {
        setCookie('ss.legacyVariation', true);
      }
      checkLegacyVariation();
    });
  };
})(window.GaTest = window.GaTest || {}, jQuery);
(function (Header, $, undefined) {

  var initStickyNavListener = function initStickyNavListener() {
    $(document).on('ss.scrollDirectionChanged', function (e, data) {
      switch (data.direction) {
        case 'up':
          $('body').addClass('sticky-nav-active--w-header');
          break;
        case 'down':
          $('body').removeClass('sticky-nav-active--w-header');
          break;
        default:
          break;
      }
    });
  };

  var initHeaderStyleChange = function initHeaderStyleChange() {
    var scrollTopOffset = $(window).scrollTop();
    if (scrollTopOffset > 0) {
      $('.site-header').removeClass('site-header--transparent');
    } else {
      $('.site-header').addClass('site-header--transparent');
    }
  };

  var determineHeaderStyle = function determineHeaderStyle() {
    if ($('.cta-hero').length > 0) {
      $('body').addClass('transparent-header');
      $('.site-header').addClass('site-header--transparent');

      $(document).on('ready', function () {
        initHeaderStyleChange();
      });

      $(window).on('scroll', function () {
        initHeaderStyleChange();
      });
    }
  };

  var bindUIActions = function bindUIActions() {
    $('[data-toggle-mobile-nav]').on('click', function () {
      $('body').toggleClass('scroll-lock');
      $('.hamburger').toggleClass('active');
      $('.site-header__nav').slideToggle();
      if ($('.inline-cart').is(':visible')) {
        $('body').removeClass('cart-open');
      }
    });

    $('body').on('click', function () {
      $('.site-header__linklist-sub').slideUp(300);
      $('.site-header__link').removeClass('site-header__link--highlighted');
    });

    $('[data-is-owner]').on('click', function (e) {
      e.preventDefault();
      var isOwner = $(this).attr('data-is-owner') === 'true';
      var trackName = isOwner ? 'Support Clicked by Owner' : 'Support Clicked by Non-Owner';
      analytics.track(trackName);
      setCookie('ss.isOwner', isOwner);
    });

    $('[data-toggle-submenu]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if (!$(this).hasClass('site-header__link--highlighted')) {
        $(this).closest('ul').find('> li > ul').slideUp(300);
        $(this).closest('ul').find('> li > a').removeClass('site-header__link--highlighted');
      } else {
        $(this).next().find('.site-header__linklist-sub').slideUp(300);
        $(this).next().find('.site-header__link--highlighted').removeClass('site-header__link--highlighted');
      }
      $(this).closest('.site-header__linklist-item--has-sub').siblings().find('.site-header__linklist-sub').slideUp();
      $(this).closest('.site-header__linklist-item--has-sub').siblings().find('.site-header__link--highlighted').removeClass('site-header__link--highlighted');
      $(this).next().slideToggle(300);
      $(this).toggleClass('site-header__link--highlighted');
    });
  };

  Header.init = function () {
    if ($('[data-sticky-nav-trigger]').length) {
      initStickyNavListener();
    }
    determineHeaderStyle();
    bindUIActions();
  };
})(window.Header = window.Header || {}, jQuery);
(function (Index, $, undefined) {

  var video = $('#index-video').get(0);

  var initWaypoints = function initWaypoints() {
    var headerOffset = $('.site-header').outerHeight();
    var navOffset = $('[data-scroll-nav]').outerHeight();
    var waypointOffset = headerOffset + navOffset;

    $('[data-toggle-floating-button]').waypoint(function () {
      $('.floating-btn').toggleClass('floating-btn--visible');
      $('.share-widget').toggleClass('share-widget--visible');
    }, {
      offset: Variables.headerHeight
    });

    // if ($(window).width() >= 1024) {
    //   $('[data-waypoint-nav-toggle]').waypoint(function(direction) {
    //     $('.section-menu-nav').toggleClass('section-menu-nav--sticky');
    //   }, {
    //     offset: Variables.getSectionNavOffset()
    //   }); 
    // }
  };

  var inlineVideo = function inlineVideo() {
    enableInlineVideo(video);
  };

  var bindUIActions = function bindUIActions() {
    $('[data-tab]').on('click', function (e) {
      var tabIndex = $(this).attr('data-tab');

      e.preventDefault();
      $(this).closest('.tabs').find('.tabs__content-wrapper').hide();
      $(this).closest('.tabs').find('.tabs__content-wrapper[data-tab-index="' + tabIndex + '"]').show();
    });

    $('[data-toggle-section-modal]').on('click', function () {
      $(this).closest('.feature-summary').find('.feature-summary__modal').toggleClass('feature-summary__modal--active');
      if ($(window).width() < 1024) {
        $('body').toggleClass('modal-open scroll-lock');
      }
    });

    $(document).on('click', '[data-section-menu-btn]', function () {
      Scroll.pauseWaypointFunctions = true;
      $('.section-menu__btn').removeClass('section-menu__btn--active');
      $(this).addClass('section-menu__btn--active');
    });

    $(document).on('click', '[data-play-hero-video]', function () {
      $(this).closest('.cta-hero').addClass('cta-hero--playing');
      video.play();
      video.onended = function (e) {
        video.load();
        $(this).closest('.cta-hero').removeClass('cta-hero--playing');
      };
    });
  };

  // Public
  Index.init = function () {
    bindUIActions();
    initWaypoints();
    inlineVideo();
  };
})(window.Index = window.Index || {}, jQuery);
(function (InlineCart, $, undefined) {

  // Private
  var lineItemEntryPoint = $('[data-cart-contents]');
  var shopCartEntryPoint = $('[data-shop-cart]');
  var isShopPage = window.location.pathname === '/collections/all';
  var header = $('[data-header]');

  var getCartContents = function getCartContents() {
    $.get('/cart?view=ajax', function (response) {
      lineItemEntryPoint.html(response);
    });
  };

  var getShopCartContents = function getShopCartContents() {
    $.get('/cart?view=shop', function (response) {
      shopCartEntryPoint.html(response);
    });
  };

  var addLineItem = function addLineItem(self) {
    var variantId = $(self).attr('data-variant-id');
    var variantTitle = $(self).attr('data-variant-title');
    var variantQty = parseInt($(self).attr('data-variant-quantity'));
    var variantPrice = parseFloat($(self).attr('data-variant-price'));
    var value = variantQty * variantPrice;
    var productId = $(self).attr('data-product-id');
    var productTitle = $(self).attr('data-product-title');

    var lineProperties = {};

    CartJS.addItem(variantId, variantQty, lineProperties, {
      "success": function success(data, textStatus, jqXHR) {
        console.log({
          id: productId,
          name: productTitle,
          price: variantPrice,
          quantity: variantQty,
          value: value,
          variantId: variantId,
          variantTitle: variantTitle
        });

        window.optimizely.push(["trackEvent", "add-to-cart"]);

        // TRACK SEGMENT EVENT
        analytics.track('Product Added', {
          id: productId,
          name: productTitle,
          price: variantPrice,
          quantity: variantQty,
          value: value,
          variantId: variantId,
          variantTitle: variantTitle
        });

        // Trigger correct GA funnel
        ga('send', { 'hitType': 'pageview', 'page': '/cart', 'title': 'Added to Cart' });

        if (productId === '2320515843' || productId === '1988450947') {
          CartJS.addItem(5689440387, 1);
          CartJS.addItem(7905522243, 1);
        } else if (productId === '1620954349658' || productId === '1346004942938') {
          CartJS.addItem(17163560878170, 1);
        }

        triggerInlineCart();
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        // Define an error callback to display an error message.
        window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
      }
    });
  };

  var removeLineItem = function removeLineItem(e, self) {
    var variantId = $(self).attr('data-variant-id');
    if (e) {
      e.preventDefault();
    }
    CartJS.updateItemById(variantId, 0);
  };

  var triggerInlineCart = function triggerInlineCart(e) {
    if (e) {
      e.preventDefault();
    }
    $('body').addClass('cart-open scroll-lock');
  };

  var toggleInlineCart = function toggleInlineCart(e) {
    if (e) {
      e.preventDefault();
    }
    $('body').toggleClass('cart-open scroll-lock');
  };

  var closeInlineCart = function closeInlineCart(e) {
    if (e) {
      e.preventDefault();
    }
    $('body').removeClass('cart-open scroll-lock');
  };

  function getItemById(variant_id) {
    for (var i = 0; i < CartJS.cart.items.length; i++) {
      var item = CartJS.cart.items[i];

      if (item.id == variant_id) {
        return item;
      }
    }
  }

  function checkIfItems() {
    if (isShopPage) {
      getShopCartContents();
    }
  }

  // Event Bindings
  var bindUIActions = function bindUIActions() {
    $(document).on('click', '[data-cart-close]', closeInlineCart);
    $(document).on('click', '[data-cart-open]', triggerInlineCart);

    $(document).on('click', '[data-add-to-cart]', function () {
      if ($(this).is('[data-disabled]')) {
        console.log('here');
      } else {
        addLineItem(this);
      }
    });

    $(document).on('click', '[data-quantity]', function (e) {
      var max = parseInt($(this).siblings('.qty-control__qty').attr('data-max'));
      var quantity = parseInt($(this).data('quantity'));
      var update = parseInt($(this).data('update'));
      var $message = $(this).closest('.line-item').find('[data-message]');
      if (quantity > max) {
        $message.html('Sorry, max quantity for this item is ' + max + '. Click <a class="text-link" href="/pages/contact-sales">here</a> for wholesale information.');
        return false;
      } else {
        CartJS.updateItem(update, quantity);
      }
    });

    $(document).on('click', '[data-remove-item]', function (e) {
      removeLineItem(e, this);
    });

    $(document).on('click', '[data-toggle-cart]', function (e) {
      toggleInlineCart(e);
      if ($('.hamburger').hasClass('active')) {
        $('.hamburger').removeClass('active');
        $('.site-header__nav').hide();
      }
    });

    $(document).on('click', '[data-close-cart]', function (e) {
      closeInlineCart();
    });

    $(document).on('cart.requestStarted', function (event, cart) {
      $('.cart-wrapper').addClass('loading');
      if (window.cartSliderActive) {
        window.currentCartSlide = parseInt($('[data-cart-slider]').slick('slickCurrentSlide'));
      }
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      getCartContents();
      checkIfItems();
      if (CartJS.cart.item_count === 0) {
        setTimeout(function () {
          closeInlineCart();
        }, 1000);
      }
    });

    $(document).on('ready', function () {
      if (window.location.hash == '#cart-open') {
        toggleInlineCart();
      }
    });
  };

  // Public
  InlineCart.init = function () {
    bindUIActions();
    getCartContents();
    checkIfItems();
  };
})(window.InlineCart = window.InlineCart || {}, jQuery);
(function (Modal, $, undefined) {

  var timesModalSeen = void 0;
  var player = void 0;
  var videoType = void 0;

  var triggerNewsletterModal = function triggerNewsletterModal() {
    timesModalSeen = getCookie('ss.newsletterModalSeen') || 0;
    timesModalSeen = parseInt(timesModalSeen);

    if (timesModalSeen < 1) {
      var inst = $('[data-remodal-id=newsletter]').remodal();
      setTimeout(function () {
        inst.open();
      }, 30000);
    }
  };

  var bindUIActions = function bindUIActions() {
    $(document).on('closed', '[data-remodal-id="newsletter"]', function (e) {
      setCookie('ss.newsletterModalSeen', timesModalSeen + 1, 365);
    });

    $(document).on('opened', '[data-video-modal]', function () {
      var iframe = $(this).find('iframe');
      videoType = iframe.attr('src').match('vimeo') ? 'vimeo' : 'youtube';

      if (videoType === 'vimeo') {
        player = new Vimeo.Player(iframe);
        player.ready().then(function () {
          if (window.innerWidth > 1024) {
            player.play();
          }
        });
      } else {
        player = iframe[0].contentWindow;
        console.log(player);
        if (window.innerWidth > 1024) {
          player.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }
      }
    });

    $(document).on('closing', '[data-video-modal]', function () {
      if (videoType === 'vimeo') {
        player.unload();
      } else {
        player.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      }
    });
  };

  Modal.init = function () {
    triggerNewsletterModal();
    bindUIActions();
  };
})(window.Modal = window.Modal || {}, jQuery);
(function (Promotions, $, undefined) {

  var bindUIActions = function bindUIActions() {

    var productVariants = {
      65: '8436277443',
      25: '8436320131',
      tag: '5689418691'
    };

    if (queryParams.promo === 'dads') {
      CartJS.addItem(productVariants[25]);
    }
  };

  Promotions.init = function () {
    bindUIActions();
  };
})(window.Promotions = window.Promotions || {}, jQuery);
(function (QueryParams, $, undefined) {

  QueryParams.init = function () {
    window.queryParams = parseURL(window.location).searchObject;
  };
})(window.QueryParams = window.QueryParams || {}, jQuery);
(function (Scroll, $, undefined) {

  Scroll.pauseWaypointFunctions = false;
  Scroll.scrollDirection;
  Scroll.smoothScroll = function ($target, offset, speed) {
    if (!speed) {
      speed = 600;
    } else {
      speed = parseInt(speed);
    }
    $('html, body').animate({
      scrollTop: $($target).offset().top - offset
    }, speed).promise().done(function () {
      Scroll.pauseWaypointFunctions = false;
    });
  };

  var lastScrollPosition = window.scrollY;

  var bindUIActions = function bindUIActions() {
    $(document).on('click', '[data-scroll]', function (e) {
      var $scrollTarget = $(this).attr('data-scroll');
      var offset = $(this).attr('data-scroll-offset');
      var offsetMobile = $(this).attr('data-scroll-offset-mobile');
      var speed = $(this).attr('data-scroll-speed');

      // if offset contains letter it must be an element 
      // and not a set pixel value. Checking for that here.
      if (/[a-z]/gi.test(offset)) {
        var offset = $(offset).outerHeight();
        var offsetMobile = $(offsetMobile).outerHeight();
      }

      if (offsetMobile && $(window).width() <= 1024) {
        offset = offsetMobile;
      }

      e.preventDefault();
      Scroll.smoothScroll($scrollTarget, offset, speed);
    });

    window.onscroll = function () {
      var newScrollPosition = window.scrollY;
      var currentScrollDirection = void 0;

      if (newScrollPosition < lastScrollPosition) {
        currentScrollDirection = 'up';
      } else {
        currentScrollDirection = 'down';
      }

      if (currentScrollDirection !== Scroll.scrollDirection) {
        Scroll.scrollDirection = currentScrollDirection;
        $(document).trigger('ss.scrollDirectionChanged', [{
          direction: Scroll.scrollDirection
        }]);
      }

      lastScrollPosition = newScrollPosition;
    };
  };

  var initStickyNav = function initStickyNav() {
    if ($(window).width() >= 1024) {
      new Waypoint({
        element: $('[data-sticky-nav-trigger]'),
        handler: function handler() {
          $('body').toggleClass('sticky-nav-active');
        },
        offset: Variables.headerHeight
      });
    }
  };

  Scroll.init = function () {
    bindUIActions();
    if ($('[data-sticky-nav-trigger]').length) {
      initStickyNav();
    }
  };
})(window.Scroll = window.Scroll || {}, jQuery);
(function (SectionNav, $, undefined) {

  var updateActiveSectionNavItem = function updateActiveSectionNavItem(currentSection) {
    $('[data-section-anchor]').removeClass('active');
    $('[data-section-anchor="' + currentSection + '"]').addClass('active');
  };

  var initSectionNav = function initSectionNav() {
    var currentSection = void 0;

    $('[data-section]').each(function () {
      new Waypoint({
        element: $(this),
        handler: function handler(direction) {
          if (direction === 'down') {
            currentSection = $(this.element).attr('data-section');
            if (!Scroll.pauseWaypointFunctions) {
              updateActiveSectionNavItem(currentSection);
            }
          }
        },
        offset: Variables.sectionMenuHeight
      });

      new Waypoint({
        element: $(this),
        handler: function handler(direction) {
          if (direction === 'up') {
            currentSection = $(this.element).prev().attr('data-section');
            if (!Scroll.pauseWaypointFunctions) {
              updateActiveSectionNavItem(currentSection);
            }
          }
        },
        offset: Variables.headerHeight + Variables.sectionMenuHeight
      });
    });
  };

  var bindUIActions = function bindUIActions() {
    $(document).on('click', '[data-section-anchor]', function (e) {
      var sectionAnchor = $(this).attr('data-section-anchor');
      var $section = $('[data-section="' + sectionAnchor + '"]');
      var sectionOffset = $section.offset().top;
      var isSticky = $('.sticky-nav-active').length;
      var offset = void 0;

      if (sectionOffset > window.scrollY) {
        offset = Variables.sectionMenuHeight;
      } else {
        offset = Variables.headerHeight + Variables.sectionMenuHeight;
      }

      updateActiveSectionNavItem(sectionAnchor);

      Scroll.pauseWaypointFunctions = true;
      Scroll.smoothScroll($section, offset, 300);
    });
  };

  SectionNav.init = function () {
    initSectionNav();
    bindUIActions();
  };
})(window.SectionNav = window.SectionNav || {}, jQuery);
(function (ShareWidget, $) {

  window.popupCenter = function (url, w, h) {
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, '', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    if (window.focus) {
      newWindow.focus();
    }
  };

  function prettifyCount(count) {
    count = count > 1000 ? count.toString().charAt(0) + '.' + count.toString().charAt(1) + 'k' : count;
    var i = 4 - count;
    while (i > 2) {
      count += ' &nbsp;';
      i--;
    }
    return count;
  }

  var initShareWidget = function initShareWidget() {
    $.get('https://graph.facebook.com/https://shop.soloshot.com').done(function (response) {
      $('[data-share-facebook]').attr('data-count', prettifyCount(response.share.share_count));
    });

    $.ajax({
      url: 'https://api.pinterest.com/v1/urls/count.json?url=https://shop.soloshot.com',
      dataType: 'jsonp'
    }).done(function (response) {
      $('[data-share-pinterest]').attr('data-count', prettifyCount(984 + response.count));
    });
  };

  var bindUIActions = function bindUIActions() {
    document.querySelector('[data-share-facebook]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Facebook'
      });
      FB.ui({
        method: 'share',
        display: 'popup',
        href: window.location.href
      });
    };

    document.querySelector('[data-share-twitter]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Twitter'
      });
      var url = window.location.hostname;
      var text = 'Automatically capture, edit, share and manage professional-quality video with SOLOSHOT at ' + url + ' via @SOLOSHOTupdates';
      var shareUrl = "http://www.twitter.com/intent/tweet?text=" + encodeURIComponent(text);
      popupCenter(shareUrl, 600, 253);
    };

    document.querySelector('[data-share-email]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Email'
      });
      var url = window.location.hostname;
      var subject = 'Automatically capture, edit, share and manage professional-quality video with SOLOSHOT.';
      var body = 'Film yourself with SOLOSHOT, the Robot Cameraman. You wear the Tag, and the Base automatically pans, tilts & zooms to keep you in the camera\'s shot. See more at ' + url;
      window.location.href = "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
    };

    document.querySelector('[data-share-pinterest]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Pinterest'
      });
      PinUtils.pinOne({
        'url': window.location.hostname + "?utm_source=pinterest&utm_medium=pin&utm_campaign=share_widget",
        'media': '{{ "fb-open-graph.jpg" | asset_url }}',
        'description': 'Film yourself with SOLOSHOT, the Robot Cameraman. You wear the Tag, and the Base automatically pans, tilts & zooms to keep you in the camera\'s shot.'
      });
    };
  };

  ShareWidget.init = function () {
    bindUIActions();
    initShareWidget();
  };
})(window.ShareWidget = window.ShareWidget || {}, jQuery, undefined);
(function (Shop, $, undefined) {

  var bindUIActions = function bindUIActions() {
    $('#shopify-section-social-slider').insertBefore('[data-social-anchor]').addClass('active');
    $('#shopify-section-social-slider-plus').insertBefore('[data-social-anchor]').addClass('active');

    $('[data-radio-feature]').on('click', function (e) {
      var radioId = $(this).attr('data-radio-feature');
      var radioUrl = $(this).attr('data-url');
      var variantQty = $(this).attr('data-variant-quantity');
      var variantId = $(this).attr('data-variant-id');
      var variantPrice = $(this).attr('data-variant-price');
      var variantTitle = $(this).attr('data-variant-title');
      var productId = $(this).attr('data-product-id');
      var productTitle = $(this).attr('data-product-title');

      $(this).closest('.radio-feature__radios').find('.radio-feature__radio-btn').removeClass('radio-feature__radio-btn--selected');
      $(this).find('.radio-feature__radio-btn').addClass('radio-feature__radio-btn--selected');
      $(this).closest('.radio-feature').find('.radio-feature__image').hide();
      $(this).closest('.radio-feature').find('.radio-feature__image[data-radio-feature="' + radioId + '"]').show();

      $('[add-to-cart-radio]').attr({
        'data-variant-quantity': variantQty,
        'data-variant-id': variantId,
        'data-variant-price': variantPrice,
        'data-variant-title': variantTitle,
        'data-product-id': productId,
        'data-product-title': productTitle
      });

      $('[radio-link]').attr('href', radioUrl);
    });
  };

  var checkSelectedProductParam = function checkSelectedProductParam() {
    if (queryParams.product === "25") {
      $('[data-radio-feature="8436320131"]').trigger('click');
    }
  };

  Shop.init = function () {
    bindUIActions();
    checkSelectedProductParam();
  };
})(window.Shop = window.Shop || {}, jQuery);
(function (Sliders, $, undefined) {

  var handleSliderClick = function handleSliderClick(self, direction) {
    var $sliderContainer = $(self).closest('[data-parallax-slider]');
    var $activeSlide = $sliderContainer.find('.parallax-section--active');
    var slideCount = $sliderContainer.find('.parallax-section').length;
    var currentSlideIndex = parseInt($activeSlide.attr('data-slide-index'));
    var slideToShowIndex = void 0;

    if (direction === 'prev') {
      slideToShowIndex = currentSlideIndex - 1;
    } else {
      slideToShowIndex = currentSlideIndex + 1;
    }

    if (slideToShowIndex > slideCount) {
      slideToShowIndex = 1;
    } else if (slideToShowIndex === 0) {
      slideToShowIndex = slideCount;
    }

    $activeSlide.removeClass('parallax-section--active');
    $sliderContainer.find('[data-slide-index="' + slideToShowIndex + '"]').addClass('parallax-section--active');
  };

  var initSliders = function initSliders() {
    // $('.pr-slider-desktop').slick({
    //   dots: true,
    //   customPaging: function(slider, i) {
    //     var thumb = $(slider.$slides[i]).data('thumb');
    //     return '<a><img class="pr-slider__slide-img" src="'+thumb+'"></a>';
    //   },
    //   appendDots: $('.pr-dots'),
    //   fade: true
    // })

    $('.pr-slider-mobile').slick({
      dots: true
    });

    $('.pr-slider-mobile').slick('slickGoTo', 2);

    $('.social-slider').slick({
      mobileFirst: true,
      centerMode: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: true
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerPadding: '125px'
        }
      }, {
        breakpoint: 1480,
        settings: {
          slidesToShow: 4,
          centerPadding: '125px'
        }
      }]
    });
  };

  var bindUIActions = function bindUIActions() {

    $('[data-parallax-slide-prev]').on('click', function () {
      handleSliderClick(this, 'prev');
    });

    $('[data-parallax-slide-next]').on('click', function () {
      handleSliderClick(this, 'next');
    });
  };
  // Public
  Sliders.init = function () {
    bindUIActions();
    initSliders();
  };
})(window.Sliders = window.Sliders || {}, jQuery);
(function (StoreLocator, $, undefined) {

  var addCustomLink = function addCustomLink() {
    var checkIfMap = setInterval(function () {
      if ($('#storemapper-left').length) {
        var $retailLinkContainer = $('<div />', { class: 'retail-link-container' });
        var $retailLinkHeading = $('<h1 />', { class: 'section-heading', text: 'Store Locator' });
        var $retailLink = $('<a />', { class: 'retail-link', href: 'https://soloshot.com/pages/contact-sales', text: 'Become a Retailer' });
        $retailLinkHeading.appendTo($retailLinkContainer);
        $retailLink.appendTo($retailLinkContainer);
        $('#storemapper-form').prepend($retailLinkContainer);
        clearInterval(checkIfMap);
      }
    }, 100);
  };

  StoreLocator.init = function () {
    addCustomLink();
  };
})(window.StoreLocator = window.StoreLocator || {}, jQuery);
var Variables = function () {

  var varObject = {
    desktopLarge: 1280,
    desktop: 1024,
    tabletLarge: 992,
    tablet: 767,
    mobileLarge: 480,
    mobile: 320,
    headerHeight: $('[data-site-header]').outerHeight(),
    sectionMenuHeight: $('[data-section-nav]').outerHeight()
  };

  return varObject;
}();